import { Spinner } from '../../components';
import { ResultsCardFrame } from '../results/ResultsCardFrame';
import type { ResultSession } from '../results/sessions';
import { useResultSessionStore } from '../results/store';
import type { BoardContextValue } from '../useBoardContext';
import { ExamDetailTab } from './ExamDetailTab';
import { ExamReportTab } from './ExamReportTab';
import { examDisplayTitle } from './examResults';
import { useExamResultStore } from './store';
import { useClassExamLoad, useExamResultsView } from './useExamResults';

export interface ExamResultsCardProps {
  session: ResultSession;
  context: BoardContextValue;
  onClose: () => void;
  onBackToDe: () => void;
}

// Real class results for the exam on this tab
export function ExamResultsCard({ session, context, onClose, onBackToDe }: ExamResultsCardProps) {
  const examId = session.refId;
  useClassExamLoad(context);
  const { view, exam, results, attemptsLoading, questionsLoading, questionsError, retryQuestions, retryAttempts } = useExamResultsView(examId);
  const titles = useExamResultStore((state) => state.courseTitles);
  const examTitles = useExamResultStore((state) => state.examTitles);
  const setPanelTab = useResultSessionStore((state) => state.setPanelTab);
  const setDetailTab = useResultSessionStore((state) => state.setDetailTab);
  const openStudent = useResultSessionStore((state) => state.openStudent);

  const subtitle = exam ? [examDisplayTitle(exam, examTitles), titles[exam.courseId] || ''].filter(Boolean).join(' • ') : session.title;
  const questionNote = questionsLoading ? <Spinner size="small" label="Đang tải câu hỏi…" /> : questionsError
    ? <p className="quiz-results__empty">Chưa tải được câu hỏi: {questionsError} <button type="button" className="hw-panel__refresh" onClick={retryQuestions}>Thử lại</button></p>
    : null;
  const actions = session.student ? <button type="button" className="hw-panel__refresh" onClick={onBackToDe}>Quay lại đề</button> : null;
  const onOpenStudent = (code: string) => openStudent(session.tabId, code);

  return (
    <ResultsCardFrame label="Kết quả bài kiểm tra" subtitle={subtitle} actions={actions} tab={session.panelTab} onTab={(tab) => setPanelTab(session.tabId, tab)} onClose={onClose}>
      {!results ? (view.kind === 'error' ? <p className="quiz-results__empty">Chưa tải được kết quả: {view.message} <button type="button" className="hw-panel__refresh" onClick={retryAttempts}>Thử lại</button></p> : <Spinner label="Đang tải kết quả của lớp…" />)
        : session.panelTab === 'report' ? <ExamReportTab results={results} questionNote={questionNote} activeCode={session.student} onOpenStudent={onOpenStudent} />
          : <ExamDetailTab results={results} tab={session.detailTab} onTab={(tab) => setDetailTab(session.tabId, tab)} activeCode={session.student} onOpenStudent={onOpenStudent} onReload={retryAttempts} reloading={attemptsLoading} questionNote={questionNote} />}
    </ResultsCardFrame>
  );
}
